<template>
  <div class="mine-service" v-cloak>
    <van-nav-bar left-arrow fixed title="个人设置" id="nav-bar" @click-left="onClickLeft"></van-nav-bar>

    <!-- 职称 -->
    <van-cell center title="头像">
      <template #right-icon>
        <van-badge content="-">
          <div class="user-img" @click="editHeadPhoto()"><img :src="userInfo.head_photo" alt=""></div>
        </van-badge>
      </template>
    </van-cell>

    <!-- 昵称 -->
    <van-cell center title="昵称" @click="editName()">
      <template #right-icon>
        <p>{{userInfo.user_nickname}}</p>
      </template>
      <template #extra>
        <van-icon name="arrow" />
      </template>
    </van-cell>

    <!-- 性别 -->
    <!-- <van-cell center title="性别">
      <template #right-icon>
        <p>{{userInfo.gender}}</p>
      </template>
      <template #extra>
        <van-icon name="arrow" />
      </template>
    </van-cell> -->

    <van-cell center title="手机号" :value="userInfo.phone_no"></van-cell>
    <van-cell center title="邀请码" :value="userInfo.invite_code"></van-cell>

    <van-dialog v-model="isNameShow" title="修改昵称" show-cancel-button confirm-button-color="#ff5000" @confirm="editNickName">
      <van-field v-model="newName" />
    </van-dialog>

    <!-- 修改头像 -->
    <van-dialog v-model="isHeadPhoto" title="上传头像" show-cancel-button confirm-button-color="#ff5000" @confirm="setHeadPhoto">
      <!-- <van-field v-model="newHeadPhoto" /> -->

      <van-field name="uploader" label="">
        <template #input>
          <van-uploader :after-read="afterRead" v-model="newHeadPhoto" name="repairPic" multiple :max-count="1" />
        </template>
      </van-field>

    </van-dialog>

    <!-- 底部按钮 disabled-->
    <div class="foot-btn">
      <van-button round color="#ff5000" block type="primary"  @click="goOut">退出登录</van-button>
    </div>

  </div>
</template>

<script type="text/babel">
import { getToken, setToken, removeToken } from "@/utils/auth";
export default {
  name: "MineService",
  components: {},
  props: {},
  data() {
    return {
      txFace: require("../../assets/mine/tx.png"),
      isNameShow: false,

      userInfo: {},
      newName: "",

      isHeadPhoto: false,
      newHeadPhoto: [],

      aa: {},
    };
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    this.getUser();
    this.getUserInfoData();
  },
  methods: {
    getUser() {
      console.log(Lockr.get("userInfo"));
      console.log(this.$store.getters.userInfo);
      this.userInfo = Lockr.get("userInfo") || this.$store.getters.userInfo; //用户信息
    },
    // 打开修改昵称弹窗
    editName() {
      // this.$toast("暂不支持修改！");
      this.isNameShow = !this.isNameShow;
      this.newName = this.userInfo.user_nickname;
    },
    // 修改昵称
    editNickName() {
      let _this = this;

      let data = {
        field: "user_nickname", //字段
        v: _this.newName, //修改内容
      };

      _this.$post("/api/user_info_save", data, data).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          // _this.isNameShow = !_this.isNameShow;
          _this.userInfo.user_nickname = _this.newName;

          let newData = {
            company_id: this.userInfo.company_id,
            head_photo: this.userInfo.head_photo,
            invite_code: this.userInfo.invite_code,
            open_id: this.userInfo.open_id,
            phone_no: this.userInfo.phone_no,
            sex: this.userInfo.sex,
            user_id: this.userInfo.user_id,
            user_nickname: this.newName,
          };

          Lockr.set("userInfo", newData); //用户信息

          _this.$store.commit("saveUser", newData);

          _this.$toast.success(res.data.message);
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    // 修改头像
    editHeadPhoto() {
      this.isHeadPhoto = !this.isHeadPhoto;
      this.newHeadPhoto = [];
    },
    // 修改头像

    setHeadPhoto() {
      var that = this;

      if (this.newHeadPhoto.length < 1) {
        this.$toast.fail("请上传图片！");
        return;
      }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      // console.log(that.newHeadPhoto);
      // console.log(that.newHeadPhoto[0]);
      // console.log(that.newHeadPhoto[0].file);

      let formData = new FormData();
      //通过append追加数据
      formData.append("file", that.newHeadPhoto[0].file); 
      // if (that.newHeadPhoto[0] && that.newHeadPhoto[0].file) {
      //   console.log("有值1");
      //   formData.append("file", that.newHeadPhoto[0].file);
      // }
      let data = {};

      // if (that.newHeadPhoto[0] && that.newHeadPhoto[0].file) {
      //   console.log("有值2");
      //   data = Object.assign(data, { file: that.newHeadPhoto[0].file });
      // }

      console.log(data);
      this.$postForm("/api/user_avatar", formData, data).then((res) => {
        console.log(res.data.data, "上唇头像");
        if (res.data && res.data.code == 0) {
          // that.$toast.clear(); //关闭弹窗
          that.$toast({ message: "提交成功~" });
          that.userInfo.head_photo = res.data.data.avatar;

          let newData = {
            company_id: this.userInfo.company_id,
            head_photo: res.data.data.avatar,
            invite_code: this.userInfo.invite_code,
            open_id: this.userInfo.open_id,
            phone_no: this.userInfo.phone_no,
            sex: this.userInfo.sex,
            user_id: this.userInfo.user_id,
            user_nickname: this.userInfo.user_nickname,
          };
          Lockr.set("userInfo", newData); //用户信息
          that.$store.commit("saveUser", newData);
        } else {
          that.$toast.fail(res.data.message);
        }
      });
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    goOut() {
      let _this = this;

      this.$dialog
        .confirm({
          title: "提示",
          message: " 是否退出登录? \n 退出后一些功能将无法使用",
          theme: "round-button",
          confirmButtonText: "取消",
          cancelButtonText: "确定",
          confirmButtonColor: "#ff5000",
          cancelButtonColor: "#CCCCCC",
        })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
          sessionStorage.clear(); //清除数据
          Lockr.rm("userId");
          _this.$store.commit("set_user_id", undefined);
          Lockr.rm("mobile");
          _this.$store.commit("set_Mobile", undefined);
          Lockr.rm("head_photo");
          Lockr.rm("userInfo");
          Lockr.rm("user_nickname");
          removeToken();

          _this.$router.push({
            name: "index",
            query: {},
          });
          window.location.reload();
        });
    },
  },
};
</script>

<style lang="scss">
.mine-service {
  .van-field__control--custom {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

<style lang="scss" scoped>
.mine-service {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;
  text-align: left;
}
.user-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.foot-btn {
  position: fixed;
  bottom: 20px;
  left: 0;
  // height: 40px;
  width: 100%;
  // background-color: #fff;
  padding: 0 15px;
}
</style>
